module.exports = "<dk-bank-account-list></dk-bank-account-list>\r\n";